const APP_CODES = Object.freeze({
    OPEN : 'OPEN',
    MANAGEMENT_CONSOLE: 'MANAGEMENT_CONSOLE',
    TEST: 'TEST'
});

export default APP_CODES;